import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/icons/HelpCircleIcon.tsx
var i = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M21 12C21 7.02948 16.9705 3 12 3C7.02948 3 3 7.02948 3 12C3 16.9705 7.02948 21 12 21C16.9705 21 21 16.9705 21 12ZM12.0098 16C12.5621 16 13.0098 16.4477 13.0098 17C13.0098 17.5523 12.5621 18 12.0098 18H12C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16H12.0098ZM9.89355 6.54688C10.7079 6.06823 11.6656 5.89303 12.5967 6.05273C13.5276 6.2125 14.3722 6.69632 14.9805 7.41895C15.5885 8.14133 15.9211 9.05585 15.9199 10C15.9199 11.5309 14.785 12.5418 13.9746 13.082C13.539 13.3724 13.1106 13.5863 12.7949 13.7266C12.6359 13.7973 12.5019 13.8509 12.4053 13.8877C12.357 13.9061 12.3176 13.9205 12.2891 13.9307C12.2748 13.9357 12.2627 13.9394 12.2539 13.9424C12.2496 13.9439 12.2461 13.9453 12.2432 13.9463C12.2418 13.9467 12.2403 13.9469 12.2393 13.9473L12.2373 13.9482C12.237 13.9483 12.2361 13.9487 11.9199 13L12.2363 13.9482C11.7125 14.1229 11.1464 13.8402 10.9717 13.3164C10.7971 12.7926 11.0798 12.2265 11.6035 12.0518L11.6191 12.0459C11.6346 12.0404 11.6601 12.0312 11.6934 12.0186C11.7608 11.9929 11.8607 11.9525 11.9824 11.8984C12.2292 11.7887 12.5509 11.6275 12.8652 11.418C13.5548 10.9582 13.9199 10.4691 13.9199 10V9.99805C13.9207 9.52578 13.7543 9.06836 13.4502 8.70703C13.146 8.34567 12.7233 8.10329 12.2578 8.02344C11.7924 7.94371 11.3133 8.03121 10.9062 8.27051C10.4991 8.50989 10.1899 8.88645 10.0332 9.33203C9.84993 9.85267 9.27958 10.1262 8.75879 9.94336C8.23776 9.76019 7.96331 9.18899 8.14648 8.66797C8.45985 7.77682 9.07919 7.02559 9.89355 6.54688ZM23 12C23 18.0751 18.0751 23 12 23C5.92492 23 1 18.0751 1 12C1 5.92492 5.92492 1 12 1C18.0751 1 23 5.92492 23 12Z",
		fill: "currentColor"
	})
}), a = {
	12: {
		Artwork: i,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M8.00635 10.5835C8.42056 10.5835 8.75635 10.9193 8.75635 11.3335C8.75635 11.7477 8.42056 12.0835 8.00635 12.0835H8.00049C7.58628 12.0835 7.25049 11.7477 7.25049 11.3335C7.25049 10.9193 7.58628 10.5835 8.00049 10.5835H8.00635Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.55322 4.29248C7.11307 3.9634 7.77156 3.84291 8.41162 3.95264C9.05179 4.06244 9.63303 4.39613 10.0513 4.89307C10.4689 5.38953 10.6975 6.01774 10.6968 6.6665C10.6968 7.73125 9.90809 8.42697 9.36279 8.79053C9.06736 8.98749 8.77727 9.13225 8.56396 9.22705C8.45624 9.27493 8.36495 9.31142 8.29932 9.33643C8.26661 9.34888 8.23973 9.35878 8.22021 9.36572C8.21057 9.36915 8.20284 9.37243 8.19678 9.37451C8.19381 9.37553 8.19103 9.37576 8.18896 9.37646C8.18794 9.37681 8.18683 9.37718 8.18604 9.37744L8.18506 9.37842C7.7921 9.5094 7.36585 9.29677 7.23486 8.90381C7.10412 8.51102 7.31677 8.08661 7.70947 7.95557C7.71091 7.95507 7.71341 7.95436 7.71826 7.95264C7.72798 7.94918 7.74439 7.94333 7.76611 7.93506C7.8098 7.91841 7.87505 7.89228 7.95459 7.85693C8.11628 7.78507 8.32624 7.67883 8.53076 7.54248C8.98538 7.23937 9.19678 6.935 9.19678 6.6665C9.19727 6.37129 9.09293 6.08475 8.90283 5.85889C8.71282 5.63313 8.4495 5.48113 8.15869 5.43115C7.86772 5.38124 7.5675 5.43584 7.31299 5.58545C7.05869 5.73499 6.86601 5.97027 6.76807 6.24854C6.63069 6.6393 6.2018 6.8449 5.81104 6.70752C5.42053 6.56999 5.2157 6.1421 5.35303 5.75146C5.56845 5.13875 5.99331 4.62162 6.55322 4.29248Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.00049 0.583496C12.0964 0.583672 15.4165 3.90452 15.4165 8.00049C15.4163 12.0963 12.0963 15.4163 8.00049 15.4165C3.90452 15.4165 0.583672 12.0964 0.583496 8.00049C0.583496 3.90441 3.90441 0.583496 8.00049 0.583496ZM8.00049 2.0835C4.73284 2.0835 2.0835 4.73284 2.0835 8.00049C2.08367 11.268 4.73294 13.9165 8.00049 13.9165C11.2679 13.9163 13.9163 11.2679 13.9165 8.00049C13.9165 4.73294 11.268 2.08367 8.00049 2.0835Z",
					fill: "currentColor"
				})
			]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: i,
		width: 20,
		height: 20
	},
	24: {
		Artwork: i,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, tone: r = "default", className: i, ...o }) => /* @__PURE__ */ n(e, {
	source: a[t],
	monochrome: !0,
	className: ["pf-icon-" + r, i].filter(Boolean).join(" "),
	...o
});
//#endregion
export { o as HelpCircleIcon };
